import { ref, Ref } from 'vue'

export type DropHandler = (e: DragEvent) => void

export const useDragAndDrop = (dropHandler: DropHandler) => {
  const dropEl: Ref<HTMLElement | undefined> = ref()
  const overDropEl: Ref<boolean> = ref(false)

  let _counter = 0
  const onDragEnter = (e: DragEvent) => {
    e.preventDefault()
    e.stopPropagation()

    _counter++
    overDropEl.value = true
  }

  const onDragOver = (e: DragEvent) => {
    e.preventDefault()
    e.stopPropagation()

    overDropEl.value = true
  }

  const onDragLeave = (e: DragEvent) => {
    e.preventDefault()
    e.stopPropagation()

    _counter--
    if (_counter === 0) overDropEl.value = false
  }

  const onDrop = (e: DragEvent) => {
    e.preventDefault()
    e.stopPropagation()

    overDropEl.value = false
    _counter = 0

    if (dropHandler) {
      dropHandler(e)
    }
  }

  const init = () => {
    dropEl.value?.addEventListener('dragenter', onDragEnter, false)
    dropEl.value?.addEventListener('dragover', onDragOver, false)
    dropEl.value?.addEventListener('dragleave', onDragLeave, false)
    dropEl.value?.addEventListener('drop', onDrop, false)
  }

  const destroy = () => {
    dropEl.value?.removeEventListener('dragenter', onDragEnter)
    dropEl.value?.removeEventListener('dragover', onDragOver)
    dropEl.value?.removeEventListener('dragleave', onDragLeave)
    dropEl.value?.removeEventListener('drop', onDrop)
  }

  return {
    dropEl,
    overDropEl,
    init,
    destroy,
  }
}
